import { createClient } from '@prismicio/client';

export const repo = 'bardiciousart';
export const client = createClient(repo);
